<template>
  <div id="contenedor-main-contrato-grafica-comparativa-avances">
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <line-chart
            :chart-data="data"
            :options="options">
          </line-chart>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import LineChart from '@/components/charts/LineChart';
import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinanciero';
import mixAvanceFisico from '@/helpers/calculos/mixAvanceFisico';

export default {
  name: 'MainContratoGraficaComparativaAvances',
  components: {
    LineChart,
  },
  mixins: [mixAvanceProgramado, mixAvanceFinanciero, mixAvanceFisico],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    importeDelContrato() {
      if (!this.contrato) return 0;
      const { importe: importeModificado } = this.contrato.modificado;
      if (this.contrato.esObraFinanciada) {
        return (this.contrato.importeTotal + importeModificado);
      }
      return (this.contrato.importeTotal + importeModificado);
    },
    getUltimaFechaFinanciero() {
      const fechasFinanciero = this.mixGetAvanceFinanciero
        .map(({ fechaTermino }) => fechaTermino)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return fechasFinanciero.pop();
    },
    getUltimaFechaProgramado() {
      const fechasPrograma = this.mixGetPrograma
        .map(({ fechaTermino }) => fechaTermino)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return fechasPrograma.pop();
    },
    getUltimaFechaFisico() {
      const fechasFisico = this.mixGetAvanceFisico
        .map(({ fecha }) => fecha)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return fechasFisico.pop();
    },
    fechas() {
      const fechasFinanciero = this.mixGetAvanceFinanciero
        .map(({ fechaTermino }) => fechaTermino);
      const fechasPrograma = this.mixGetPrograma
        .map(({ fechaTermino }) => fechaTermino);
      const fechasFisico = this.mixGetAvanceFisico
        .map(({ fecha }) => fecha);
      const fechas = [...fechasFinanciero, ...fechasPrograma, ...fechasFisico]
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return [...new Set(fechas)];
    },
    getAvanceFinancieroALaFecha() {
      return this.fechas
        .filter((fecha) => {
          if (!this.getUltimaFechaFinanciero) return false;
          return new Date(fecha) <= new Date(this.getUltimaFechaFinanciero);
        })
        .map((fecha) => ({
          fecha,
          avance: this.mixAvanceFinancieroALaFecha(fecha).avance || 0,
        }));
    },
    getAvanceProgramadoALaFecha() {
      return this.fechas
        .filter((fecha) => {
          if (!this.getUltimaFechaProgramado) return false;
          return new Date(fecha) <= new Date(this.getUltimaFechaProgramado);
        })
        .map((fecha) => ({
          fecha,
          avance: this.mixCalcularPrograma(fecha).porcentaje || 0,
        }));
    },
    getAvanceFisicoALaFecha() {
      return this.fechas
        .filter((fecha) => {
          if (!this.getUltimaFechaFisico) return false;
          return new Date(fecha) <= new Date(this.getUltimaFechaFisico);
        })
        .map((fecha) => ({
          fecha,
          avance: this.mixAvanceFisicoFecha(fecha) || 0,
        }));
    },
    data() {
      return {
        labels: ['', ...this.fechas],
        datasets: [
          {
            label: 'Avance Programado',
            fill: false,
            data: [0, ...this.getAvanceProgramadoALaFecha.map(({ avance }) => avance)],
            borderColor: '#2196F3',
            tension: 0.1,
          },
          {
            label: 'Avance Financiero',
            fill: false,
            data: [0, ...this.getAvanceFinancieroALaFecha.map(({ avance }) => avance)],
            borderColor: '#607D8B',
            tension: 0.1,
          },
          {
            label: 'Avance Físico',
            fill: false,
            data: [0, ...this.getAvanceFisicoALaFecha.map(({ avance }) => avance)],
            borderColor: '#E91E63',
            tension: 0.1,
          },
        ],
      };
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#line-chart {
  height:200px !important;
}
</style>
